import { render } from "./BuildingList.vue?vue&type=template&id=0d06c100&scoped=true"
import script from "./BuildingList.vue?vue&type=script&lang=js"
export * from "./BuildingList.vue?vue&type=script&lang=js"

import "./BuildingList.vue?vue&type=style&index=0&id=0d06c100&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d06c100"]])

export default __exports__